<div class="container-fluid">
  <div class="row manageaccount mt-3">
    <div class="col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-end">
        <button
          class="btn btn-dark btn-sm"
          matTooltip="Back"
          matTooltipPosition="left"
          mat-raised-button
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>

      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item" routerLink="/superAdmin/lrmanagement">
            Manage LR
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Edit Tracker
          </li>
        </ol>
      </nav>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-xl-12">
      <form [formGroup]="editLR" (ngSubmit)="EditTrackerSubmit()">
        <div class="col-md-12 mb-3">
          <h4 class="text-dark fw-bold mb-0">Edit Tracker</h4>
          <p style="font-size: 13px">Edit your following details.</p>
        </div>

        <div class="contentbox mb-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Basic Details</h4>
            </div>

            <div class="row">
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Supervisor Name </label>
                  <select
                    id="supervisornamectrl"
                    formControlName="supervisorname"
                    placeholder="Select Status"
                    class="form-control shadow-none"
                  >
                    <option selected value="null">
                      --Select Supervisor Name--
                    </option>
                    <option *ngFor="let s of superVisor" value="{{ s._id }}">
                      {{ s.full_name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Company Name</label>

                  <select
                    *ngIf="isRoleSuperVisor"
                    id="clientListctrl"
                    formControlName="clientList"
                    placeholder="Select Company Name"
                    class="form-control shadow-none"
                  >
                    <!-- <option   value="">--Select Client Name--</option> -->
                    <option *ngFor="let cl of clientList" value="{{ cl._id }}">
                      {{ cl.clientName }}
                    </option>
                  </select>
                  <select
                    disabled
                    *ngIf="!isRoleSuperVisor"
                    id="clientListctrl"
                    formControlName="clientList"
                    placeholder="Select Client Name"
                    class="form-control shadow-none"
                  >
                    <!-- <option   value="">--Select Client Name--</option> -->
                    <option *ngFor="let cl of clientList" value="{{ cl._id }}">
                      {{ cl.clientName }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Date -->
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="datectrl"
                    >Date<sup class="text-danger">*</sup></label
                  >
                  <input
                    type="date"
                    id="datectrl"
                    class="form-control shadow-none"
                    placeholder="Enter Date"
                    formControlName="date"
                    (change)="onKeyDate($event)"
                    [min]="isRoleSuperVisor ? yesterday : null"
                    [max]="isRoleSuperVisor ? today : null"
                  />

                  <span
                    class="text-danger"
                    *ngIf="
                      ff.date.invalid && (ff.date.touched || submitLRClicked)
                    "
                  >
                    Please enter date
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="contentbox">
          <div class="row account">
            <div class="col-xl-12">
              <!-- Vehicle Information Section -->
              <div class="row">
                <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
                  <h4 class="text-dark fw-bold mb-0">Vehicle Information</h4>
                </div>

                <!-- First Row -->
                <div class="row">
                  <!-- Vehicle Number -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp mb-3">
                      <label for="VehicleNoctrl"
                        >Vehicle No.<sup class="text-danger">*</sup></label
                      >
                      <input
                        type="text"
                        id="VehicleNoctrl"
                        class="form-control shadow-none"
                        placeholder="Enter Vechicle No."
                        formControlName="VehicleNo"
                        [matAutocomplete]="autoVehicleNo"
                      />
                      <mat-autocomplete
                        autoActiveFirstOption
                        #autoVehicleNo="matAutocomplete"
                      >
                        <mat-option
                          *ngFor="let option of filteredVehicleNo | async"
                          [value]="option"
                        >
                          {{ option }}
                        </mat-option>
                      </mat-autocomplete>

                      <span
                        class="text-danger"
                        *ngIf="
                          ff.VehicleNo.invalid &&
                          (ff.VehicleNo.touched || submitLRClicked)
                        "
                      >
                        Please enter Vehicle number
                      </span>
                    </div>
                  </div>

                  <!-- Vehicle Type -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp">
                      <label for="">Vehicle Type</label>
                      <input
                        type="text"
                        id="vehicleTypectrl"
                        class="form-control shadow-none"
                        placeholder="Enter Vehicle Type"
                        formControlName="vehicleType"
                        [matAutocomplete]="autoVehicleType"
                      />
                      <mat-autocomplete
                        autoActiveFirstOption
                        #autoVehicleType="matAutocomplete"
                      >
                        <mat-option
                          *ngFor="let option of filteredVehicleTypes | async"
                          [value]="option"
                        >
                          {{ option }}
                        </mat-option>
                      </mat-autocomplete>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp">
                      <label for="fixAdhocctrl"
                        >FIX / Adhoc<sup class="text-danger">*</sup></label
                      >
                      <select
                        formControlName="fixAdhoc"
                        id="fixAdhocctrl"
                        class="form-control shadow-none"
                      >
                        <option disabled value="">--Select FIX/Adhoc--</option>
                        <option value="FIX">FIX</option>
                        <option value="Adhoc">Adhoc</option>
                        <option value="Replacement">Replacement</option>
                      </select>
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.fixAdhoc.invalid &&
                          (ff.fixAdhoc.touched || submitLRClicked)
                        "
                      >
                        Please enter fixAdhoc
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Second Row -->
                <div class="row">
                  <!-- From -->
                  <div class="col-lg-4 col-md-6 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp">
                      <label for="">From</label>
                      <input
                        *ngIf="isRoleSuperVisor"
                        type="text"
                        id="fromctrl"
                        class="form-control shadow-none"
                        placeholder="Enter From"
                        formControlName="from"
                      />
                      <input
                        disabled
                        *ngIf="!isRoleSuperVisor"
                        type="text"
                        id="fromctrl"
                        class="form-control shadow-none"
                        placeholder="Enter From"
                        formControlName="from"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.from.invalid &&
                          (ff.from.touched || submitLRClicked)
                        "
                      >
                        Please enter value
                      </span>
                    </div>
                  </div>

                  <!-- To -->
                  <div class="col-lg-4 col-md-6 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp">
                      <label for="">To</label>
                      <input
                        *ngIf="isRoleSuperVisor"
                        type="text"
                        id="toctrl"
                        class="form-control shadow-none"
                        placeholder="Enter To"
                        formControlName="to"
                      />
                      <input
                        disabled
                        *ngIf="!isRoleSuperVisor"
                        type="text"
                        id="toctrl"
                        class="form-control shadow-none"
                        placeholder="Enter To"
                        formControlName="to"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.to.invalid && (ff.to.touched || submitLRClicked)
                        "
                      >
                        Please enter value
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Trip information -->
        <div class="contentbox mt-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Trip Details</h4>
            </div>
            <div class="col-xl-12">
              <div class="row">
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Starting Meter Reading</label>
                    <div class="d-flex align-items-center">
                      <input
                        *ngIf="isRoleSuperVisor"
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter Meter Reading"
                        id="startmeterReadingctrl"
                        formControlName="startmeterReading"
                      />
                      <input
                        disabled
                        *ngIf="!isRoleSuperVisor"
                        type="text"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter Meter Reading"
                        id="startmeterReadingctrl"
                        formControlName="startmeterReading"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.startmeterReading.invalid &&
                          (ff.startmeterReading.touched || submitLRClicked)
                        "
                      >
                        Please enter Start Meter Reading
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">End Meter Reading</label>
                    <div class="align-items-center">
                      <input
                        (focusout)="onFocusOutendmeterReading($event)"
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter  Meter Reading"
                        id="endmeterReadingctrl"
                        formControlName="endmeterReading"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.endmeterReading.invalid &&
                          ff.endmeterReading.touched
                        "
                      >
                        Only numbers should be accepted
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for=""
                      >Trip Starting Date<sup class="text-danger">*</sup></label
                    >
                    <div class="d-flex align-items-center">
                      <input
                        type="date"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter Start Time"
                        id="tripSDatectrl"
                        formControlName="tripSDate"
                      />
                    </div>
                    <span
                      class="text-danger"
                      *ngIf="
                        ff.tripSDate.invalid &&
                        (ff.tripSDate.touched || submitLRClicked)
                      "
                    >
                      Please enter Trip Starting Date
                    </span>
                  </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Trip End Date</label>
                    <div class="d-flex align-items-center">
                      <input
                        type="date"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter End Time"
                        id="tripEDatectrl"
                        formControlName="tripEDate"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for=""
                      >Trip Starting Time<sup class="text-danger">*</sup></label
                    >
                    <div class="d-flex align-items-center">
                      <input
                        type="time"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter Start Time"
                        id="outtimectrl"
                        formControlName="outtime"
                      />
                    </div>
                    <span
                      class="text-danger"
                      *ngIf="
                        ff.outtime.invalid &&
                        (ff.outtime.touched || submitLRClicked)
                      "
                    >
                      Please enter Trip Starting Time
                    </span>
                  </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Trip End Time</label>
                    <div class="d-flex align-items-center">
                      <input
                        type="time"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter End Time"
                        id="INtimectrl"
                        formControlName="INtime"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="contentbox mt-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Usage & Tolls</h4>
            </div>
            <div class="col-xl-12">
              <div class="row">
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Number of Tolls</label>
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter Tolls"
                        id="noofToolsctrl"
                        formControlName="noofTools"
                      />
                      <span
                        class="text-danger"
                        *ngIf="ff.noofTools.invalid && ff.noofTools.touched"
                      >
                        Only numbers should be accepted
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Total Toll Tax Paid</label>
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter Tolls Tax Paid"
                        id="tooltaxPaidctrl"
                        formControlName="tooltaxPaid"
                      />
                      <span
                        class="text-danger"
                        *ngIf="ff.tooltaxPaid.invalid && ff.tooltaxPaid.touched"
                      >
                        Only numbers should be accepted
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Usage KM</label>
                    <div class="align-items-center">
                      <input
                        disabled
                        type="text"
                        class="form-control me-1 shadow-none"
                        placeholder="KM"
                        id="updownkmctrl"
                        readonly
                        formControlName="updownkm"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Total Hours</label>
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Total Hours"
                        id="totalhourctrl"
                        readonly
                        formControlName="totalhour"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Extra Hours</label>
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Extra Hours"
                        id="extrahourctrl"
                        formControlName="extrahour"
                      />
                      <span
                        class="text-danger"
                        *ngIf="ff.extrahour.invalid && ff.extrahour.touched"
                      >
                        Only numbers should be accepted
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- payment -->
        <div class="contentbox mb-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Payment Details</h4>
            </div>

            <div class="row">
              <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Vehicle Rate</label>
                  <div class="d-flex align-items-center">
                    <input
                      *ngIf="isRoleSuperVisor"
                      type="number"
                      class="form-control me-1 shadow-none"
                      placeholder="Vehicle Rate"
                      id="vehicleRatectrl"
                      formControlName="vehicleRate"
                    />
                    <input
                      disabled
                      *ngIf="!isRoleSuperVisor"
                      type="text"
                      class="form-control me-1 shadow-none"
                      placeholder="Vehicle Rate"
                      id="vehicleRatectrl"
                      formControlName="vehicleRate"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Advance</label>
                  <div class="d-flex align-items-center">
                    <input
                      *ngIf="isRoleSuperVisor"
                      type="number"
                      class="form-control me-1 shadow-none"
                      placeholder="Advance"
                      id="advancectrl"
                      formControlName="advance"
                    />

                    <input
                      disabled
                      *ngIf="!isRoleSuperVisor"
                      type="text"
                      class="form-control me-1 shadow-none"
                      placeholder="Advance"
                      id="advancectrl"
                      formControlName="advance"
                    />
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Balance Paid</label>
                  <div class="d-flex align-items-center">
                    <input
                      type="number"
                      class="form-control me-1 shadow-none"
                      placeholder="Balance Paid"
                      disabled
                      (focusout)="onFocusOutEvent($event)"
                      id="balancePaidctrl"
                      formControlName="balancePaid"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Actual Balance</label>
                  <div class="d-flex align-items-center">
                    <input
                      *ngIf="isRoleSuperVisor"
                      type="number"
                      class="form-control me-1 shadow-none"
                      placeholder="Actual Balance"
                      id="balancectrl"
                      formControlName="balance"
                      readonly
                    />
                    <input
                      disabled
                      *ngIf="!isRoleSuperVisor"
                      type="text"
                      class="form-control me-1 shadow-none"
                      placeholder="Balance"
                      id="balancectrl"
                      formControlName="balance"
                    />
                  </div>
                </div>
              </div>

              <!-- TDS -->
              <div class="col-lg-3 col-md-4">
                <label>TDS</label>
                <input
                  type="number"
                  class="form-control shadow-none"
                  id="TDSctrl"
                  formControlName="TDS"
                />
              </div>

              <!-- Munsipal Amount -->
              <div class="col-lg-3 col-md-4">
                <label>Munsipal Amount</label>
                <input
                  type="number"
                  class="form-control shadow-none"
                  id="munsipalAmountctrl"
                  formControlName="munsipalAmount"
                />
              </div>

              <!-- Final Amount (MANUAL INPUT) -->
              <div class="col-lg-3 col-md-4">
                <label>Final Amount</label>
                <input
                  type="number"
                  class="form-control shadow-none"
                  id="finalAmountctrl"
                  formControlName="finalAmount"
                />
              </div>

              <!-- Other Payment -->
              <div class="col-lg-3 col-md-4">
                <label>Other Payment</label>
                <input
                  type="number"
                  class="form-control shadow-none"
                  id="otherPaymentctrl"
                  formControlName="otherPayment"
                />
              </div>

              <!-- Other Payment Description -->
              <div class="col-lg-6 col-md-6">
                <label>Other Payment Description</label>
                <input
                  type="text"
                  class="form-control shadow-none"
                  id="otherPaymentDescriptionctrl"
                  formControlName="otherPaymentDescription"
                />
              </div>
            </div>
          </div>
        </div>

          <!-- Compliance & Value -->
        <div class="contentbox mt-3">
          <div class="row account">
            <!-- Basic Details Section -->
            <div class="col-xl-12">
              <!-- Vehicle Information Section -->
              <div class="row">
                <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
                  <h4 class="text-dark fw-bold mb-0">Compliance & Value</h4>
                </div>

                <!-- First Row -->
                <div class="row">
                  <!-- DLY -->
                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for="DLYctrl">DLY</label>
                      <input
                        type="text"
                        id="DLYctrl"
                        class="form-control shadow-none"
                        placeholder="Enter DLY"
                        formControlName="DLY"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.DLY.invalid && (ff.DLY.touched || submitLRClicked)
                        "
                      >
                        Please enter DLY
                      </span>
                    </div>
                  </div>
                  <!-- Order Id -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp mb-3">
                      <label for="orderIdctrl">Order Id</label>
                      <div class="d-flex align-items-center">
                        <input
                          type="text"
                          class="form-control me-1 shadow-none"
                          id="orderIdctrl"
                          placeholder="Enter order Id."
                          formControlName="orderId"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12 mb-2">
          <div class="contentbox mt-3">
            <div class="row account">
              <div class="col-xl-12">
                <div class="row">
                  <div class="col-xl-12">
                    <div
                      class="d-flex align-items-baseline justify-content-between"
                    >
                      <h1 class="fs-4 fw-bold mb-0">Invoice Details</h1>
                      <button
                        class="btn btn-dark btn-sm"
                        mat-raised-button
                        type="button"
                        (click)="addnewinv(this.particlarLR?._id)"
                      >
                        + Add New Invoice
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3 table-responsive">
                <table
                  datatable
                  class="tablelist"
                  *ngIf="this.particlarLR?.invoice_no?.length > 0"
                >
                  <thead>
                    <tr>
                      <th>Number of Article</th>
                      <th>Invoice No.</th>
                      <th>Customer Name</th>
                      <th>Invoice Value</th>
                      <th>Weight</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let inv of this.particlarLR?.invoice_no">
                      <td>{{ inv.NoofArticle || "N/A" }}</td>
                      <td>{{ inv.InvoiceNo || "N/A" }}</td>
                      <td>{{ inv.customerName || "N/A" }}</td>
                      <td>{{ inv.InvoiceValue || "N/A" }}</td>
                      <td>{{ inv.Weight || "N/A" }}</td>
                      <td>
                        <button
                          (click)="editInvoice(inv, particlarLR?._id)"
                          type="button"
                          class="btn btn-block p-0 shadow-none"
                        >
                          <i matTooltip="Edit" class="fas fa-pen"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-end">
          <button class="btn btn-dark" type="submit" mat-raised-button>
            Update
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
